import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { styled } from "@mui/material/styles";

// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const CardContentNoPadding = styled(CardContent)(
    ` padding: 0;
  &:last-child {
    padding-bottom: 4px;
  }
`);

const Tower = ({ handleHoverEvent, handleClickEvent, searchMarker, geometry, properties }) => {
    return (
        <Card
            sx={{ my: '4px', borderRadius: '4px', opacity: properties.isFiltered ? 0.55 : 1 }}
            onMouseEnter={handleHoverEvent}
            onMouseLeave={handleHoverEvent}
            onClick={handleClickEvent}
            data-latitude={geometry.coordinates[1]}
            data-longitude={geometry.coordinates[0]}
            elevation={0}
        >

            <CardHeader
                sx={{ px: '4px', py: '1px', color: "#283891" }}
                title={<Typography lineHeight="1.5" fontWeight="bold" variant="subtitle1" componenet="h1">
                    {properties["Assest Nick Name"]}
                </Typography>
                }
                subheader={
                    <Typography variant="caption" color="#283891" component="h2">
                        {properties["City"] !== '' && properties["State"] !== '' ?
                            `${properties["City"]}, ${properties["State"]}`
                            :
                            <span>&nbsp;</span>
                        }
                    </Typography>
                }
            >
            </CardHeader>

            <CardContentNoPadding sx={{ px: '4px', py: '3px' }}>

                {searchMarker && properties.POIDistance > 0 &&
                    <Typography sx={{ fontSize: 13, fontWeight: 'bold' }} color="text.secondary">
                        {properties.POIDistance} miles from search selection
                    </Typography>
                }

                <Typography sx={{ fontSize: 13 }} color="text.secondary">
                    Overall Tower Height: {properties['Overall Tower Height']}
                </Typography>
                
                {/* <Typography sx={{ fontSize: 13 }} color="text.secondary">
                    Available RAD1: {properties['Available RAD RAD 1(s)']}
                </Typography>
                <Typography sx={{ fontSize: 13 }} gutterBottom color="text.secondary">
                    Available RAD2: {properties['Available RAD 2(s)']}
                </Typography>

                <Typography sx={{ fontSize: 13 }} color="text.secondary">
                    Zoned for Collocation: {properties['Zoned for Collocation']}
                </Typography> */}

                <Typography sx={{ fontSize: 13 }} color="text.secondary">
                    Ground Space Available: {properties['Ground Space Available']}
                </Typography>

            </CardContentNoPadding >

            {/* <CardActions sx={{ padding: '4px' }}>
                <Button href="https://google.com" target="_blank" size="small">View Documents FOR {properties["Assest Nick Name"]}</Button>
            </CardActions> */}
        </Card>

    );
}

export default Tower;